import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
export interface SpinnerState {
    show: boolean;
}
@Injectable()
export class SpinnerService {
    private spinnerSubject = new Subject<SpinnerState>();
    public spinnerState = this.spinnerSubject.asObservable();
    private spinnerQueue = 0;
    constructor() { }
    show() {
        if (++this.spinnerQueue == 1) {
            this.spinnerSubject.next(<SpinnerState>{show: true});
        }
    }
    hide() {
        if (this.spinnerQueue > 0 && --this.spinnerQueue == 0) {
            this.spinnerSubject.next(<SpinnerState>{show: false});
        }
    }
}






// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/spinner/spinner.service.ts